<template>
    <div class="app-inner"> 
         <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="onSubmit('ruleForm')"
            >
             {{$route.query.id ? '修改' : '保存'}}
           </el-button>
            </div> 
             <div class="edit-from">
                 <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
         <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
             <el-form-item label="解决方案名称：" prop="title">
                    <el-input v-model="form.title" placeholder="请输入解决方案名称" clearable></el-input>
                </el-form-item>
                    <el-form-item label="选择关联分类：" prop="class">
                     <el-checkbox-group v-model="checkList" @change="classSelectType">
                  <el-checkbox label="1">和隆优化官网</el-checkbox>
                  <el-checkbox label="2">和隆软件官网</el-checkbox>
              </el-checkbox-group>
                    <el-select v-model="form.class" placeholder="选择关联分类">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                      <el-form-item label="解决方案首图：" prop="logo">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :disabled="uploadBoolean"
                    :before-upload="$util.beforeUpload"
                    :on-error="upLoaderror"
                    >
                    <img :src="form.logo" class="avatar" v-if="form.logo">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                     <div @click.stop="uploadPicture('flagImg')" class="uploadPicture"  v-if="form.logo" >点击裁剪</div>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.logo" alt="">
                    </el-dialog>
                    </el-upload>
                    <div>建议大小：1920*560px 最大限制5M，支持JPG，PNG格式上传</div>
                 </el-form-item>
                    <el-form-item label="解决方案描述：" prop="description">
                    <el-input
                        type="textarea"
                        :rows="9"
                        placeholder="使用一句话简单介绍功能【1-50】"
                        minlength="1"
                        maxlength="50"
                        v-model="form.description"
                        clearable
                        >
                        </el-input>
                   </el-form-item>
                    <el-form-item label="解决方案排序：">
                    <el-input v-model="form.sort" placeholder="请输入解决方案排序" clearable></el-input>
                </el-form-item>
            <div class="public-tit flex align-cen" style="width:100%">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  关联产品
            </div>
                <div class="mft public-btn-small">
                     <div class="public-btn-small-primary" @click="openBl">
                          关联相关应用          
                    </div>
                </div>
        </div>
        <!-- 关联应用产品 -->
         <div class="App-tab" style="width:100%">
                           <el-table
            :data="relationList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column label="应用图片" align="center">
                 <template slot-scope="scope">
                <img :src="scope.row.pic ? scope.row.pic : ''" alt="" style="display: block;width:50%;margin:0 auto">
            </template>
            </el-table-column>
            <el-table-column label="应用ID" align="center" :prop=" isShowId ? 'appId' : 'id'">
         </el-table-column>
          <el-table-column label="应用名称" align="center" prop="appName">
         </el-table-column>
         <el-table-column label="应用类型" align="center" >
            <template slot-scope="scope">
                <span>{{scope.row.type == 1 ? '客户端应用':'网页型应用'}}</span>
            </template>
         </el-table-column>
          <el-table-column label="应用分类" align="center" prop="classifyName">
         </el-table-column>
             <el-table-column label="最新版本号" align="center" prop="versionNum">
         </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            >
             <template slot-scope="scope">
            <el-button type="text" size="small" style="color:red" @click.stop="deletPro(scope.row)">删除</el-button>
             </template>
             </el-table-column>
         </el-table>
         </div>
             <el-form-item label="方案详情：" prop="type">
                <el-radio v-model="form.type" label="1" >编辑器录入</el-radio>
                <el-radio v-model="form.type" label="2">外部链接</el-radio>
              </el-form-item>
                 <el-form-item label="方案详情链接："  prop="link" class="Flex-w" v-if="form.type == 2">
                    <el-input v-model="form.link" placeholder="注意：链接需加前缀http://或https://，否则会跳转错误" clearable></el-input>
                </el-form-item>
             <div class="public-tit flex align-cen" id="addCanvas" v-if="form.type == 1 && platformAppContentList.length == 0"  style="width:100%">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  页面分类
            </div>
               <div class="mft public-btn-small">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(-1)"
                     >
                          添加分类  
                    </div>
                </div>
              </div>
               <div class="AppContent" v-if="form.type == 1">
                  <div class="moreCanvas"
                     v-for="(item,index) in platformAppContentList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                     <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> 分类{{index+1}}
                        </div>
                    </div>
                     <div class="businessList-filter-list flex align-cen">
                            <div class="fl-le flex align-cen">
                    <div class="label">分类标题：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入分类标题【1-5】" v-model="item.title" clearable
                        maxlength="5"
                        > </el-input>
                    </div>
                    </div>
                       <div class="fl-rt flex align-cen">
                    <div class="label">副标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副标题【1-50】" v-model="item.subtitle" clearable maxlength="50"> </el-input>
                    </div>
                    </div>
                       <div class="mft deletBtn"
                    @click="deletCanvas(item)"
                    >
                    删除分类
                    </div>
                    <div class="mft public-btn-small" style="padding-left:0" v-if="index == platformAppContentList.length-1">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(index+1)"
                     >
                          添加分类  
                    </div>
                </div>
                     </div>
                        <div class="quillsFLex flex align-cen">
              <quillsTemplate  @sendStatus="emitFun" :propData="item.content"
                      :currindex="index"
                    :ref="'quillTemplate' + index"
                    :placeName="'电脑端富文本'"
                    ></quillsTemplate>
                     <quillsTemplate  @sendStatus="emitFun1" :propData="item.mobileContent"
                      :currindex="index"
                    :ref="'quillTemplate1' + index"
                     :placeName="'移动端富文本'"
                    ></quillsTemplate>
                </div>
                  </div>
               </div>
                        </el-form>
             </div>
                    <el-dialog
        title="裁切封面"
        :visible.sync="cropperModel"
        width="950px"
        center
        :modal-append-to-body="false"
        v-if="cropperModel"
       >
     <cropper-image
         :Name="cropperName"
         :Logo="form.logo"
         @uploadImgSuccess = "handleUploadSuccess"
         ref="child">
     </cropper-image>
    </el-dialog>
                <!-- 选择应用弹框 -->
     <el-dialog
  title="选择相关应用"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
   @close="reback1"
  >
  <div class="forminfo"> 
    <appTemplate :selectType='centerDialogVisible'
    :importName="'solution'"
    :authType='2'
    :bussID='$route.query.id'
    :isAppId="isShowId"
    @sendStatus="classSelect"
    ref="appTemplate"
    ></appTemplate>
       <div class="authbtn flex align-cen">
             <el-button plain @click="reback1">取消</el-button>
              <el-button type="primary" class="mft" @click="onSubmit1">确认选择</el-button>
        </div>
  </div>
     </el-dialog>
    </div>
</template>
<script>
import LocaStorage from "../../../../utils/localstorage.js" //本地存储公共方法
import CropperImage from "@/components/CropperImage.vue";  //裁剪组件
import quillsTemplate from "@/components/quills";  //多富文本组件
import { editSolution,solutionClassify,getSolution} from "@/api/index/index"  //新增修改解决方案列表、解决方案分类、解决方案详情
import appTemplate from "@/views/Application/index.vue"; //将应用列表页面作为组件使用
export default {
    name:'addSolution',
     components: {
        CropperImage,
        quillsTemplate,
        appTemplate
    },
    data() {
        return {
            checkList:[],
            centerDialogVisible:false,
            isShowId:false,
            relationList:[],
            selectList:[],
            nowIndex:0,
            platformAppContentList:[],
            platformAppRelationList:[],
            oploadDialogVisible:false,
            options:[],
             loading:false,
            cropperModel:false,
            cropperName:'',
            edittext:'保存',
              headers:{},
                uploadBoolean:false,
                oploadDialogVisible: false,
            form:{
                title:'',
                class:'',
                logo:'',
                description:'',
                sort:'',
                type:'1',
                link:'',

            },
            rules:{
            title: [{ required: true, message: '请输入解决方案名称', trigger: 'blur' },
             { min: 1, max: 30, message: '长度在 1 到 50 个字符', trigger: 'blur' }
             ],
              class: [{ required: true, message: '请选择关联分类', trigger: 'change' },],
              logo: [{ required: true, message: '请上传解决方案首图', trigger: 'blur' }], 
              description:[{ required: true, message: '请输入解决方案描述', trigger: 'blur' },
             ],
             type: [{ required: true, message: '请选择方案详情类型', trigger: 'change' }],
              link: [{ required: true, message: '请输入方案详情链接', trigger: 'blur' }],
            }
        }
    }, 
    created() {
          let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        this.getDetail()
    },
    methods: {
          classSelectType(){
           let checkStr = this.checkList.join(',')
           let num = ['1,2', '2,1'].includes(checkStr);
              let officialType = ''
               num ? officialType = "" : officialType = checkStr
               num ? officialType = "" : officialType = checkStr
              this.getsolutionClassify(officialType)
      },        // 移除分类
         deletPro(data){
              let arr = []
            arr.push(data)
        let delet= this.relationList.filter(item=>!arr.some(ele=>ele.id===item.id)) 
         this.relationList = delet
        //   this.$refs.appTemplate.editfun(this.relationList) 
        },
        // 应用列表取消选择
        reback1(){
            this.$refs.appTemplate.remove()  
            if(this.$route.query.id) this.isShowId = true
             this.centerDialogVisible = false   
        },
        // 应用列表确认选择
         onSubmit1(){
           // 过滤数组中的对象，去除重复项  
                let uniqueObjects = this.selectList.filter((item, index) => {  
                  // 如果是对象，则进行去重逻辑  
                  if (typeof item === 'object' && item !== null) {  
                    // 使用 findIndex 查找数组中是否存在相同的对象  
                    return this.selectList.findIndex(otherItem => JSON.stringify(item) === JSON.stringify(otherItem)) === index;  
                  }  
                  // 如果不是对象，则直接返回 true，因为非对象元素不会重复  
                  return true;  
                });  
            this.relationList = uniqueObjects
           this.centerDialogVisible = false
        },
        classSelect(val,val1){
            this.selectList = val
           this.isShowId = val1
        },
        // 打开应用列表
          openBl(){
             this.centerDialogVisible = true     
             console.log(this.relationList)
                     this.$nextTick(function () {   
                 this.$refs.appTemplate.editfun(this.relationList)    
             })
            
           
        },
         // 分类列表
      getsolutionClassify(num){
         solutionClassify({
            name:'',
            officialType:num
         })
         .then(res =>{
          if(res.code == 0){
            this.options = res.data
          }else{
            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
          }
         })
         .catch(err =>{})
      },
       // 获取详情
        getDetail(){
            getSolution(
                {id:this.$route.query.id},
                'get')
             .then(res => {
                this.form = {
                    title:res.data.name,
                    class:res.data.classifyId,
                    logo:res.data.pic,
                    description:res.data.description,
                    sort:res.data.sort,
                    type:res.data.contentType,
                    link:res.data.content
                }
                if(this.$route.query.id) this.isShowId = true
                this.platformAppContentList = res.data.solutionContentList
                this.relationList = res.data.appList
                let num = ['1,2', '2,1'].includes(res.data.officialType);
              let officialType = ''
               num ? officialType = "" : officialType = res.data.officialType
               num ? officialType = "" : officialType = res.data.officialType
              this.getsolutionClassify(officialType)
              this.checkList = res.data.officialType.split(',')
             })
             .catch(err => {})
        },
        // 提交
        onSubmit(formName){
            this.platformAppRelationList = []
            for (const key in this.relationList) {
                this.platformAppRelationList.push(
                     {
                        appId:this.relationList[key].payType ? this.relationList[key].id : this.relationList[key].appId
                    }
                )
            }
             let params = {
                name:this.form.title,
                classifyId:this.form.class,
                pic:this.form.logo,
                description:this.form.description,
                solutionContentList:this.platformAppContentList,
                sort:this.form.sort,
                appList:this.platformAppRelationList,
                contentType:this.form.type,
                content:this.form.link
            }
            let method = "post"
            if(!this.$route.query.id) params = {...params},method = "post";
            if(this.$route.query.id) params = {...params,id:this.$route.query.id},method = "put";
             console.log(params)
             this.$refs[formName].validate((valid) => { 
                if(valid){
                     this.commentBness(params,method)
                }
              })
        },
           commentBness(params,method){
               this.loading = true
                editSolution(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id)  this.$util.Notifi('新增成功','success','fa-check'); 
                           if(this.$route.query.id) this.$util.Notifi('修改成功','success','fa-check');
                          
                                setTimeout(() => {
                           this.$router.push("/Solution")
                             }, 100);
                           }else{
                             this.loading = false
                            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
           // 子组件触发的方法
        emitFun(val,index){
            this.platformAppContentList[index].content = val
        },
            emitFun1(val,index){
            this.platformAppContentList[index].mobileContent = val
        },
           // 删除分类
        deletCanvas(data){
            let arr = []
            arr.push(data)
        let delet= this.platformAppContentList.filter(item=>!arr.some(ele=>ele ===item)) 
       this.platformAppContentList = delet
        this.nowIndex == 0 ?  this.nowIndex = 0 : this.nowIndex = this.nowIndex -1
        },
               // 添加分类
        addCanvas(index){
            if(index>=0){
                this.nowIndex=index
            }else{
                this.nowIndex=0
            }
            this.platformAppContentList.push({
                title:'',
                subtitle:'',
                content:'',
                mobileContent:''
            })
        },
           // 图片裁剪
        uploadPicture(name){
            this.cropperName = name;
            this.cropperModel = true;
            },
             //裁剪图片上传成功后
    handleUploadSuccess (data){
       this.form.logo = data.url;
      this.cropperModel = false;
    },
        // 返回
        reback(){
            this.$router.push('/Solution')
        },
          // 图片放大
         oploadImgPre(){
                this.oploadDialogVisible = true
            },
             oploadImgDel(){
                this.form.logo = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
            },
         handleAvatarSuccess(res, file) {
        this.form.logo = res.data.url
        
        if(this.form.logo){
        this.uploadBoolean = true
         }
         console.log(this.form.logo)
      },
    //   图片上传失败钩子
        upLoaderror(err){
            this.$message.error('图片上传失败')
        },
    },
}
</script>
<style lang="scss" scoped>
 .edit-from{
         margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 50%;
        }
        }
         }
         }
          .forminfo{
        margin-top: -50px;

     }
          .App-tab{
            margin: 20px 0;
            
        }
              .AppContent{
        margin: 20px 0;
        margin-bottom: 100px;
        position: relative;
        .moreCanvas{
            margin-top: 60px;
        }
        .moreCanvas:first-child{
            margin-top: 0;
        }
           .el-select1{
                width: 80%;
            }
        .fl-le{
            width: 40%;
        }
        .fl-rt {
             width: 40%;
        padding-left: 30px;
      }
      .deletBtn{
        margin-left: 30px;
        height: 32px;
        line-height: 30px;
        font-size: 14px;
        padding: 0 16px;
        border-radius: 2px;
        font-family: inherit;
        border-width: 1px;
        border-style: solid;
        text-align: center;
        vertical-align: middle;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s;
        background: #f56c6c;
        color: #fff;
      }
      .el-input,.el-cascader{
            width: 100%;
        }
     }
           ::v-deep{
            .quillsFLex{
      .quillTemplate{
        margin-right: 10px !important;
      }
    }
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 371px;
    height: 130px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
</style>